import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Music } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SpotifyConnect({ onConnectionChange }) {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkConnection();
  }, []);

  const checkConnection = async () => {
    try {
      const response = await axios.get(`${API}/spotify/auth/status`);
      setConnected(response.data.connected);
      if (onConnectionChange) onConnectionChange(response.data.connected);
    } catch (error) {
      console.error('Error checking Spotify connection:', error);
      setConnected(false);
      if (onConnectionChange) onConnectionChange(false);
    } finally {
      setLoading(false);
    }
  };

  const connectSpotify = async () => {
    try {
      // Construct the callback URL based on current window location
      const callbackUrl = `${window.location.origin}/spotify-callback`;
      console.log('Spotify connect - callback URL:', callbackUrl);
      console.log('Spotify connect - API URL:', API);
      
      const response = await axios.get(`${API}/spotify/auth/login`, {
        params: { redirect_uri: callbackUrl }
      });
      
      console.log('Spotify auth URL:', response.data.auth_url);
      console.log('Redirect URI confirmed:', response.data.redirect_uri);
      
      // Verify the auth_url contains our callback URL
      if (!response.data.auth_url.includes(encodeURIComponent(callbackUrl))) {
        console.warn('Warning: Auth URL may not contain correct callback URL');
      }
      
      window.location.href = response.data.auth_url;
    } catch (error) {
      console.error('Spotify connect error:', error);
      toast.error('Failed to connect to Spotify');
    }
  };

  if (loading) {
    return null;
  }

  if (connected) {
    return null; // Don't show anything if connected
  }

  return (
    <div className="fixed top-4 right-4 z-50" data-testid="spotify-connect-banner">
      <div className="glass-card p-4 flex items-center gap-3">
        <Music size={24} className="text-[#ff3131]" />
        <div>
          <div className="font-bold text-sm">Spotify Not Connected</div>
          <div className="text-xs opacity-80">Connect to play music</div>
        </div>
        <button
          onClick={connectSpotify}
          className="btn-primary text-sm py-2 px-4"
          data-testid="connect-spotify-button"
        >
          Connect
        </button>
      </div>
    </div>
  );
}
